import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
const {
  t,
  tf
} = I18N.ns('molten.screens.account.about');
export default {
  id: 'molten.link.About',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  name: tf('name'),
  layout: Config.get('About', 'layout', {
    group: ['help'],
    sort: '_a.c'
  }),
  handles: () => Config.get('Intercom', 'appId') != null,
  appearance: () => {
    return Config.get('About', 'appearance', {
      name: t('name')
    });
  },
  perform: () => {
    // eslint-disable-next-line security/detect-non-literal-fs-filename
    window.open(Config.get('About', 'url', 'https://www.leverege.com/company/about'), '_blank');
  }
};